/*
 * @Date: 2019-08-22 11:54:50
 * @LastEditors: pppp pppp@gmail.com
 * @LastEditTime: 2024-10-18 15:15:21
 */
import api from './api'

const url = 'install'

export default {
  getSigningState() {
    return api.get(`${url}/SigningState`)
  },
  sendBindDevice(udid) {
    return api.post(`${url}/BindDevice`,{udid: udid})
  },
/**
 * @description: 备注服务端在配置文件拿取值
 * @param {*}
 * @return {*}
 */  
 getAppdownloadlink() {
   return api.post(`${url}/getappdownloadlink`)
 },
}
/**
   * @description: pro app data
   * @param {*}
   * @return {*}
   */  
const getProAppData = (code) => {
  return api.get(`${url}/ProAppData?code=${code}`)
}
export {
  getProAppData
}


// WEBPACK FOOTER //
// ./src/api/install.js